// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var SiteContactRoleType;
(function (SiteContactRoleType) {
    SiteContactRoleType[SiteContactRoleType["Unknown"] = 5] = "Unknown";
    SiteContactRoleType[SiteContactRoleType["Patient"] = 11] = "Patient";
    SiteContactRoleType[SiteContactRoleType["Prescriber"] = 12] = "Prescriber";
    SiteContactRoleType[SiteContactRoleType["InsuranceProvider"] = 13] = "InsuranceProvider";
    SiteContactRoleType[SiteContactRoleType["PharmacyBenefitManager"] = 14] = "PharmacyBenefitManager";
    SiteContactRoleType[SiteContactRoleType["SecondaryContact"] = 16] = "SecondaryContact";
    SiteContactRoleType[SiteContactRoleType["Manufacturer"] = 17] = "Manufacturer";
    SiteContactRoleType[SiteContactRoleType["EMP"] = 18] = "EMP";
    SiteContactRoleType[SiteContactRoleType["CustomerServiceRep"] = 19] = "CustomerServiceRep";
    SiteContactRoleType[SiteContactRoleType["PrescriberSite"] = 20] = "PrescriberSite";
})(SiteContactRoleType || (SiteContactRoleType = {}));
//# sourceMappingURL=siteContactRoleType.js.map